export const formatNumber = ({
  number,
  options,
  locale = 'de-De',
}: {
  number: number;
  options?: Intl.NumberFormatOptions;
  locale?: string;
}): string => Intl.NumberFormat(locale, {
  maximumFractionDigits: options?.maximumFractionDigits || 2,
  minimumFractionDigits: options?.minimumFractionDigits || 1,
  ...options,
}).format(number === -Infinity ? 0 : number);

export const formatSwissNumber = (number: number): string => {
  if (number === -Infinity || !isFinite(number)) {
    return '0';
  }

  // Format with German locale to get comma as decimal separator
  const formatted = Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(number);

  // Replace the thousands separator (dot in German locale) with apostrophe
  return formatted.replace(/\./g, '\'') === '0,00' ? '0' : formatted.replace(/\./g, '\'');
};
